<div class="container login">
  <mat-card>
    <mat-card-title>SignUpForm</mat-card-title>
    <mat-card-subtitle>Please Enter Your Credentials</mat-card-subtitle>
    <mat-card-subtitle *ngIf="val" style="color:red">This Username is already exists.</mat-card-subtitle>

    <mat-card-content>
      <form [formGroup]="signupForm" (ngSubmit)="onsubmit()">
      <div class="row">
        <div class=col-md-6>
          <mat-form-field class="example-full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name">
            <mat-error *ngIf="signupForm.get('name').errors">
              Name is <strong>required</strong>
            </mat-error>
          </mat-form-field><br/>
          <mat-form-field>
            <mat-label>Age</mat-label>
            <input type="number" matInput formControlName="age">
            <mat-hint>Should be in between 15 to 100</mat-hint>
            <mat-error *ngIf="signupForm.get('age').errors">
              Age is <strong>required</strong>
            </mat-error>
          </mat-form-field><br/>
          <mat-form-field>
            <mat-label>Gender</mat-label>
            <mat-select formControlName="gen">
              <mat-option *ngFor="let g of gender" [value]="g">
                {{g}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="signupForm.get('gen').errors">
              Gender is <strong>required</strong>
            </mat-error>
          </mat-form-field><br/>
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email">
            <mat-hint>Fill your updated email</mat-hint>
            <mat-error *ngIf="signupForm.get('email').errors">
              Email should be <strong>correct</strong>
            </mat-error>
          </mat-form-field><br/>
        </div>
        <div class=col-md-6>
          <mat-form-field>
            <mat-label>UserName</mat-label>
            <input matInput formControlName="username">
            <mat-hint>Username is required</mat-hint>
            <mat-error *ngIf="signupForm.get('username').errors">
              Username is <strong>required</strong>
            </mat-error>
          </mat-form-field><br/>
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input type="password" matInput formControlName="password">
            <mat-hint>Password Should be upto 8 charecters</mat-hint>
            <mat-error *ngIf="signupForm.get('name').errors">
              Password should be of <strong>8 charecters</strong>
            </mat-error>
          </mat-form-field><br/>


        </div>
      </div>
      <hr>
      <button type="submit" mat-stroked-button [disabled]="!signupForm.valid" class="m-2">Submit</button>
      <button type="reset" mat-stroked-button>Reset</button><br/>
    </form>

    </mat-card-content>

  </mat-card>

</div>
